import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import i18n from 'i18n';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import { MODAL_TYPES } from 'constants/modal-types';
import { showModal, hideModal } from 'actions/modal';

const usePinProtectModal = () => {
  const dispatch = useDispatch();
  const show = useCallback(
    (cb, closeCb) => {
      const handleClose = () => {
        dispatch(hideModal());
        if (closeCb) closeCb();
      };

      innerAnalyticsVolia.postEvent({
        eventGroup: 'notification',
        eventName: 'PIN request',
        eventValue: 'show notification',
      });

      dispatch(
        showModal(MODAL_TYPES.ENTER_PIN, {
          modalTitleText: i18n.t('pc.pinConfirmation'),
          onModalBack: handleClose,
          onModalConfirm: () => {
            handleClose();
            cb();
          },
          checkOnComplete: true,
        }),
      );
    },
    [dispatch],
  );

  return show;
};

export default usePinProtectModal;
